// extracted by mini-css-extract-plugin
export var container = "_od-0";
export var dotAnimation = "_od-2";
export var dotsLoading = "_od-1";